export const common = {
  nav: {
    home: 'Accueil',
    about: 'À propos',
    skills: 'Compétences',
    projects: 'Projets',
    blog: 'Blog',
    contact: 'Contact'
  },
  hero: {
    greeting: 'Bonjour, je suis',
    name: 'Cherif Ibrahima Aïdara Sadio',
    title: 'Développeur Full Stack',
    description: 'Passionné par la création d\'applications web et mobiles innovantes. Expert en React, Node.js, Flutter et architectures modernes.',
    cta: 'Voir mes projets',
    contact: 'Me contacter'
  },
  about: {
    title: 'À propos',
    subtitle: 'de moi',
    intro: 'Développeur Full Stack passionné avec 3 ans d\'expérience dans la création d\'applications web et mobiles performantes.',
    description: 'Je me spécialise dans le développement d\'applications web complexes et d\'architectures évolutives. Mon expertise couvre l\'ensemble du cycle de développement, de la conception à la mise en production.',
    experience: 'Expérience',
    experienceValue: '3 ans',
    projects: 'Projets',
    projectsValue: '15+',
    technologies: 'Technologies',
    technologiesValue: '20+'
  },
  skills: {
    title: 'Stack',
    subtitle: 'Technique',
    viewAll: 'Voir la page compétences complète',
    categories: {
      frontend: 'Frontend',
      backend: 'Backend',
      mobile: 'Mobile',
      database: 'Bases de Données',
      api: 'API & Web',
      devops: 'DevOps',
      methodologies: 'Méthodologies'
    },
    languages: {
      javascript: 'Langage principal',
      typescript: 'Type-safe',
      python: 'Backend & IA',
      php: 'Web dynamique',
      dart: 'Mobile Flutter'
    }
  },
  projects: {
    title: 'Projets',
    subtitle: 'Marquants',
    viewAll: 'Voir tous les projets',
    viewProject: 'Voir le projet',
    technologies: 'Technologies'
  },
  experience: {
    title: 'Expérience',
    subtitle: 'Professionnelle',
    present: 'Présent'
  },
  contact: {
    title: 'Contactez',
    subtitle: 'moi',
    description: 'Vous avez un projet en tête ? N\'hésitez pas à me contacter pour en discuter.',
    form: {
      name: 'Nom complet',
      email: 'Email',
      subject: 'Sujet',
      message: 'Message',
      send: 'Envoyer le message',
      sending: 'Envoi en cours...',
      success: 'Message envoyé avec succès !',
      error: 'Erreur lors de l\'envoi du message.'
    },
    info: {
      email: 'Email',
      phone: 'Téléphone',
      location: 'Localisation'
    }
  },
  blog: {
    title: 'Blog &',
    subtitle: 'Articles techniques',
    description: 'Partage d\'expertise et retours d\'expérience',
    leadership: 'Leadership & Management',
    companies: 'entreprises',
    developers: 'développeurs dirigés',
    readMore: 'Lire l\'article',
    readTime: 'min de lecture',
    categories: {
      all: 'Tous',
      leadership: 'Leadership',
      architecture: 'Architecture',
      devops: 'DevOps',
      management: 'Management',
      backend: 'Backend',
      mobile: 'Mobile'
    }
  },
  footer: {
    rights: 'Tous droits réservés',
    builtWith: 'Construit avec',
    social: 'Réseaux sociaux'
  }
};
